{
  "title": "Hurtigartikkel",
  "newQuickArticleTitle": "Opprett ny hurtigartikkel"
}
